module.exports = __webpack_public_path__ + "img/m-bg1.d973a7f0.jpg";